// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__FU-UG","borderContainer":"SectionHeader_borderContainer__k+l49","textContainer":"SectionHeader_textContainer__SXugN"};